import { assign } from "es6-object-assign";
import { Settings } from "luxon";
var locales = {
    de: {
        lang: "de",
        notExists: "Asset existiert nicht",
        beforeStream: "Der nächste Stream beginnt",
        afterStream: "Vielen Dank fürs Zuschauen. Die Aufzeichnung steht noch nicht zur Verfügung",
        needsUrl: "Player benötigt Asset-Id, Stream-Namen oder URL",
        noFile: "Die Datei existiert nicht",
        noStream: "Der Livestream existiert nicht",
        brokenFile: "Die Datei ist zurzeit nicht abspielbar",
        brokenStream: "Der Livestream ist zurzeit nicht verfügbar",
        licenseReject: {
            "VoD.Restrict_TU_IP": "Tut uns Leid, diese Datei ist nur aus dem Netz der TU-Ilmenau verfügbar",
            "Mediathek.Password": "Tut uns Leid, diese Datei ist nur mit korrekten Zugangsdaten abrufbar",
            default: "Tut uns Leid, diese Datei ist aus ihrem aktuellen Netzwerk nicht verfügbar"
        }
    },
    en: {
        lang: "en",
        notExists: "Asset does not exist",
        beforeStream: "The next stream starts",
        afterStream: "Thank you for watching. The recording is not yet available",
        needsUrl: "Player needs asset-id, stream-name or url",
        noFile: "The file doesn't exist",
        noStream: "The live-stream doesn't exist",
        brokenFile: "The file is currently not available",
        brokenStream: "The live-stream is currently not available",
        licenseReject: {
            "VoD.Restrict_TU_IP": "Sorry, this file is only available from the network of the TU-Ilmenau",
            "Mediathek.Password": "Sorry, this file is only available with correct access credentials",
            default: "Sorry, this file is not available from your current network"
        }
    }
};
// default locale
var locale = locales.en;
export function setLocale(lang) {
    if (!locales[lang]) {
        console.error("Error: Locale " + lang + " doesn't exist");
        return;
    }
    Settings.defaultLocale = lang;
    if (Settings.defaultLocale != lang) {
        console.error("Luxon missing locale ".concat(lang));
        return;
    }
    assign(locale, locales[lang]);
    console.log("selected locale", locale);
}
export default locale;
